module.exports = __webpack_public_path__ + "static/SebastianJimenez-7d535d466328bc9f0a6aeda04b9ec1b5.jpg";